export default __webpack_public_path__ + "static/media/BgMusicCard.96b99b99.png";